/*
 * @Descripttion:
 * @version:
 * @Author: limin
 * @Date: 2021-04-14 11:47:39
 * @LastEditors: limin
 * @LastEditTime: 2021-04-17 15:22:56
 */
import {
  Lazyload,
  Toast,
  List,
  Swipe,
  SwipeItem,
  // Tabbar,
  // TabbarItem,
  Icon,
  TreeSelect,
  Tab,
  Tabs,
  NavBar,
  Stepper,
  SwipeCell,
  Button,
  Checkbox,
  CheckboxGroup,
  Popup,
  Cell,
  CellGroup,
  AddressEdit,
  Dialog,
  Sticky,
  Field,
  Skeleton,
  Loading,
  Overlay,
  Collapse,
  CollapseItem
} from "vant";
export const components = [
  Toast,
  List,
  Swipe,
  SwipeItem,
  // Tabbar,
  // TabbarItem,
  Icon,
  TreeSelect,
  Tab,
  Tabs,
  NavBar,
  Stepper,
  SwipeCell,
  Button,
  Checkbox,
  CheckboxGroup,
  Popup,
  Cell,
  CellGroup,
  AddressEdit,
  Dialog,
  Sticky,
  Field,
  Skeleton,
  Loading,
  Overlay,
  Collapse,
  CollapseItem
]
export const LazyLoad= Lazyload
export const toast= Toast
